import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { isNull } from 'lodash';

@Component({
    selector: 'app-jc3-block-2',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './jc3-block-2.component.html',
    styleUrl: './jc3-block-2.component.scss',
})
export class Jc3Block2Component implements OnChanges {
    @Input() esgData: any;
    cardsData: any = null;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['esgData']) {
            const current = changes['esgData'].currentValue;

            if (current?.cards && Object.keys(current.cards).length > 0) {
                this.cardsData = current.cards;
            }
        }
    }
}
